/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Telemedicine_NameInputs */

const en_service_telemedicine_name = /** @type {(inputs: Service_Telemedicine_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telemedicine`)
};

const fr_service_telemedicine_name = /** @type {(inputs: Service_Telemedicine_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télémédecine`)
};

/**
* | output |
* | --- |
* | "Telemedicine" |
*
* @param {Service_Telemedicine_NameInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_telemedicine_name = /** @type {((inputs?: Service_Telemedicine_NameInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Telemedicine_NameInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_telemedicine_name(inputs)
	return fr_service_telemedicine_name(inputs)
});